// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__I4V_N","title":"Images45_title__ugOB7","images":"Images45_images__vZMAZ"};